/* eslint-disable no-unused-vars */
import GenerateOverdueInvoiceChargesInvoiceDTO from './generateOverdueInvoiceChargesInvoiceDTO'

export default class GenerateOverdueInvoiceChargesClientDTO {
  constructor({
    clientID = null,
    clientGroupID = null,
    expectedUnchargedInterestExTax = 0,
    expectedOverdueInvoices = [],
  } = {}) {
    /**
     * @type {Number}
     */
    this.clientID = clientID
    /**
     * @type {Number}
     */
    this.clientGroupID = clientGroupID
    /**
     * @type {Number}
     */
    this.expectedUnchargedInterestExTax = expectedUnchargedInterestExTax
    /**
     * @type {GenerateOverdueInvoiceChargesInvoiceDTO[]}
     */
    this.expectedOverdueInvoices = expectedOverdueInvoices
  }
}
